import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesBookingEmployees } from '@components/templates';

export function ServicesBookingEmployeesPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('services-booking-employees-component.metatags.title'),
        description: t('services-booking-employees-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesBookingEmployees,
        index: false,
    });

    return <ServicesBookingEmployees />;
}
